export enum AnswerInputType {
    Text = 'text',
    RadioButton = 'radioButton',
    UnknownFutureValue = 'unknownFutureValue'
}